export const REGISTER_ACTIONS = {
	REGISTER_ACTIONS_REGISTER_USER: 'REGISTER_ACTIONS_REGISTER_USER',
	REGISTER_ACTIONS_RECEIVE_RESPONSE: 'REGISTER_ACTIONS_RECEIVE_RESPONSE',
	REGISTER_ACTIONS_GET_EMAIL_BY_CODE: 'REGISTER_ACTIONS_GET_EMAIL_BY_CODE',
	REGISTER_ACTIONS_VALIDATION_USER_IS_NEW: 'REGISTER_ACTIONS_VALIDATION_USER_IS_NEW',
	REGISTER_ACTIONS_RECEIVE_RESPONSE_EMAIL_BY_CODE: 'REGISTER_ACTIONS_RECEIVE_RESPONSE_EMAIL_BY_CODE',
	REGISTER_ACTIONS_HANDLE_USER_INFO: 'REGISTER_ACTIONS_HANDLE_USER_INFO',
	REGISTER_ACTIONS_RESET: 'REGISTER_ACTIONS_RESET'
}